import { render, staticRenderFns } from "./EventsListView.vue?vue&type=template&id=aa7da0ee&scoped=true&"
import script from "./EventsListView.vue?vue&type=script&lang=js&"
export * from "./EventsListView.vue?vue&type=script&lang=js&"
import style0 from "./EventsListView.vue?vue&type=style&index=0&id=aa7da0ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa7da0ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VAlert,VContainer,VPagination})
